import React, { useCallback, useMemo } from 'react';
import { message } from 'antd';
import ActionMenuV2 from 'components/ActionMenuV2';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { PermissionSetMap } from 'constants/RBACConstants';
import { CellRenderers } from 'utils/tableUtils';
import TableContainer from 'components/TableContainer';
import BackstageConfigForm from './BackstageConfigForm';
import { EditIcon } from 'components/Icons';
import ModalUtil from "utils/modalUtil";
const actions = [
	{
		type: "edit",
		text: "Edit",
		icon: <EditIcon/>,
		permission: PermissionSetMap.EDIT_TOOL_CONFIG
	},
	{
		type: "delete",
		permission: PermissionSetMap.DELETE_TOOL,
	}
];

function BackstageListing({data, onUpdateConfigComponent, ...props}) {
    const onDelete = useCallback((id) => {
		return ToolsIntegrationsAPI.deleteBackstageConfiguration(id).promise.then((res) => {
			message.success(res);
			onUpdateConfigComponent();
		}).catch(err => message.error(err));
	}, [onUpdateConfigComponent]);

    const onActionClick = useCallback(async (e, { name, data }) => {
		switch (name) {
			case "edit":
				ModalUtil.show({
					content: <BackstageConfigForm configData = {data}/>,
					afterClose: (success) => success && onUpdateConfigComponent()
				})
				break;
			case "delete":
				await onDelete(data.id);
				break;
			default:
				break;
		}
	}, [onDelete, onUpdateConfigComponent]);

	const columns = useMemo(()=>(
		[{
			title: "Name",
			dataIndex: "name",
			key: "name",
		},
        {
			title: "URL",
			dataIndex: "hostUrl",
			key: "hostUrl",
			render: CellRenderers.VALUE_OR_NA
		},
        {
			title:"Action",
			render: (record) => <ActionMenuV2 items={actions} onClick={onActionClick} data={record}/>
		}]), [onActionClick]);
		
	return (<TableContainer dataSource={props.loginConfigList} columns={columns}/>)
}

export default BackstageListing